// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js'

// IE 11 polyfill
import 'custom-event-polyfill';
import 'promise-polyfill/src/polyfill';

// import local dependencies
import Router from './util/Router';
import common from './routes/init';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js